"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _root = _interopRequireDefault(require("./style/root"));

var _react = _interopRequireWildcard(require("react"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Control = _react["default"].forwardRef(function (_ref, ref) {
  var style = _ref.style,
      theme = _ref.theme,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["style", "theme", "children"]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style, theme]);
  return _react["default"].createElement(_root["default"], (0, _extends2["default"])({
    theme: memoTheme
  }, rest, {
    ref: ref
  }), children);
});

Control.propTypes = {
  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default 0
     */
    marginTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 3 + 'px'
     */
    marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    marginRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    marginLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  children: _propTypes["default"].any
};
var _default = Control;
exports["default"] = _default;